import FirebaseApp from "../../../firebaseApp";
/* eslint-disable */
const state = {
  diets: []
};

const getters = {
  getDiets(state) {
    return state.diets;
  }
};

const mutations = {
  store(state, diet) {
    state.diets.push(diet);
  },
  update(state, data) {
    state.diets[data.diet.indexRef] = data;
  },
  deleteData(state, indexRef) {
    state.diets.splice(indexRef, 1);
  }
};
const actions = {
  async update({ commit, rootGetters }, data) {
    await FirebaseApp.db
      .collection("users")
      .doc(rootGetters["auth/userId"])
      .collection("dietas")
      .doc(data.diet.id)
      .set(data)
      .then(() => {
        commit("update", data);
      })
      .catch(error => {
        alert("🤕 " + error.message);
      });
  },
  async store({ commit, rootGetters }, diet) {
    await FirebaseApp.db
      .collection("users")
      .doc(rootGetters["auth/userId"])
      .collection("dietas")
      .add(diet)
      .then(data => {
        diet.diet.id = data.id;
        commit("store", diet);
      })
      .catch(error => alert("🤕" + error.message));
  },
  async index({ commit, rootGetters }) {
    let diet = null;
    FirebaseApp.db
      .collection("users")
      .doc(rootGetters["auth/userId"])
      .collection("dietas")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          diet = doc.data();
          diet.diet.id = doc.id;
          commit("store", diet);
        });
      })
      .catch(error => {
        alert("🤕 " + error.message);
      });
  },
  async deleteData({ commit, rootGetters }, { item, indexRef }) {
    await FirebaseApp.db
      .collection("users")
      .doc(rootGetters["auth/userId"])
      .collection("dietas")
      .doc(item.diet.id)
      .delete()
      .then(() => {
        commit("deleteData", indexRef);
      })
      .catch(error => {
        alert("🤕 " + error.message);
      });
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
